
import {initWebComponent} from "@/helpers/web-component-helper";
import {WKT} from "ol/format";
import {Geometry, Polygon} from "ol/geom";
import {fromExtent} from "ol/geom/Polygon";
import {getActiveFilter} from "@/helpers/filter/filter-helper";
import {initPopper} from "@/modules/popper";
import {getBookmarkPresentationsByID} from "@/helpers/ol/ol-layer-helper.js";

export class LayerInfoFilterResultChartButtonComponent extends HTMLElement {
    constructor() {
        super();

        const bookmarkPresentationID = this.getAttribute('data-bookmark-presentation-id')

        const template = document.createElement('template');
        template.innerHTML = `
        <button class="btn btn-sm btn-outline-secondary icon-btn text-transform-none popper-header" href="#">
          <span class="fa fa-chart-bar"></span>
          <div class="popper-tooltip" role="tooltip" data-popper-placement="top">
             Bekijk grafiek
            <div class="arrow" data-popper-arrow=""></div>
          </div>
        </button>`;

        initWebComponent(this, template)

        initPopper()

        this.addEventListener('click', () => {
            let filters = ''
            window.filterData.columns.map(column => {
                if(column.search.value) {
                    filters += '&filter_' + column.data + '=' + column.search.value
                }
            })

            const wkt = new WKT()
            if(window.filterData.geometry) {
                // const geometry = new Polygon(window.filter_geom)
                filters += '&filter_' + window.filterData.geometry.column + '=' + wkt.writeGeometry(window.filter_geom_28992)
            }

            const bookmarkPresentation = getBookmarkPresentationsByID(bookmarkPresentationID)
            const portalBookmarkPresentation = bookmarkPresentation.PortalBookmarkPresentation

            if(portalBookmarkPresentation) {
                let apiName = portalBookmarkPresentation.presentation.ApiName
                if (!apiName) {
                    apiName = portalBookmarkPresentation.presentation.DisplayName
                }

                let url = window.kaartViewerUrl + '/portaal/index.html?website=' + portalBookmarkPresentation.bookmark_group.bookmark.Naam + '&page=dataset&sortBy=&dataset=' + apiName +  '&tab=grafiek' + filters

                url = url.replaceAll('(', '%28')
                url = url.replaceAll(')', '%29')
                url = url.replaceAll(',', '%2C')
                url = url.replaceAll('.', '.')
                url = url.replaceAll(' ', '%20')

                window.open(url, 'dataportaal')
            } else {
                toastr.warning('Geen dataportaal gevonden. Neem contact op met de beheerder')
            }
        })
    }
}
